import { render, staticRenderFns } from "./FeeAssetsLineChart.vue?vue&type=template&id=1ca6d5fb&"
import script from "./FeeAssetsLineChart.vue?vue&type=script&lang=js&"
export * from "./FeeAssetsLineChart.vue?vue&type=script&lang=js&"
import style0 from "./FeeAssetsLineChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/_vuetify-loader@1.7.2@vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
